import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NumericTextBoxModule, NumericTextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { RolesService } from './roles.service';
import { RolesComponent } from './roles.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { RolesRoutingModule } from './roles-routing.module';
import { HttpClient } from '@angular/common/http';
@NgModule({
  declarations: [
    RolesComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    RolesRoutingModule,

  ],
  providers: [RolesService, ColumnChooserService, PageService, SortService, FilterService, ResizeService, HttpClient],
})
export class RolesModule { }
